import { render, staticRenderFns } from "./PackagesV2.vue?vue&type=template&id=91c5077e&scoped=true&"
import script from "./PackagesV2.vue?vue&type=script&lang=js&"
export * from "./PackagesV2.vue?vue&type=script&lang=js&"
import style0 from "./PackagesV2.vue?vue&type=style&index=0&id=91c5077e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "91c5077e",
  null
  
)

export default component.exports